var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.8 86.4",
    enableBackground: "new 0 0 100.8 86.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M43,69.4c0.2,1,0.3,2.1,0.3,3.2c0,3.6-1.2,6.9-3.2,9.6h20.4c-2-2.7-3.2-6-3.2-9.6c0-1.1,0.1-2.2,0.3-3.2 H43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M99.8,65.8c0,2.1-1.7,3.8-3.8,3.8H4.5c-2.1,0-3.8-1.7-3.8-3.8V12c0-2.1,1.7-3.8,3.8-3.8H96 c2.1,0,3.8,1.7,3.8,3.8V65.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666766",
    d: "M0.7,59.7V7c0-2.1,1.7-3.8,3.8-3.8H96c2.1,0,3.8,1.7,3.8,3.8v52.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 8.1,
    fill: "#272727",
    width: 89.2,
    height: 46.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666766",
    cx: 50.3,
    cy: 64.4,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M66.1,82.6c0,0.2-0.2,0.4-0.4,0.4H34.8c-0.2,0-0.4-0.2-0.4-0.4v-3.2c0-0.2,0.2-0.4,0.4-0.4h30.9 c0.2,0,0.4,0.2,0.4,0.4V82.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#26D7FD",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M60.4,28.9 c1.7-1.7,2.2-4.1,1.5-6.2c-0.1-0.2-0.3-0.3-0.5-0.1L58.9,25c-0.9,0.9-2.3,1-3.2,0.2c-1-0.9-1-2.4-0.1-3.3l2.6-2.6 c0.2-0.2,0.1-0.4-0.1-0.5c-2.2-0.8-4.7-0.2-6.4,1.6c-1.7,1.8-2,4.4-1.1,6.5l-8.4,8.4c-1.1-0.2-2.3,0.2-3.2,1.1 c-1.5,1.5-1.5,3.9,0,5.4c1.5,1.5,3.9,1.5,5.4,0c0.9-0.9,1.2-2.1,1.1-3.2l8.4-8.4C56,31.1,58.6,30.7,60.4,28.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#26D7FD",
    cx: 41.4,
    cy: 39.2,
    r: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.da29c95f84d31bc0d2d5967ac67bbdb8.svg";
export { ForwardRef as ReactComponent };